import { render, staticRenderFns } from "./CampaignStatement.vue?vue&type=template&id=08397a13&scoped=true&"
import script from "./CampaignStatement.vue?vue&type=script&lang=js&"
export * from "./CampaignStatement.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/black-dashboard/views/_campaign-statement.scss?vue&type=style&index=0&id=08397a13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08397a13",
  null
  
)

export default component.exports